import { useQuery } from '@apollo/client'
import React, { useEffect, useState } from 'react'
import { GET_ALL_SCHEDULE_GROUPS } from '../../../../../graphql/Catalog/Employees/Groups/scheduleGroups'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import LayoutTable from '../../../../Global/LayoutTable'
import ContentHeader from '../../../../Layout/ContentHeader'
import moment from 'moment'

const ScheduleGroups = () => {
  const [layoutInfor, setLayoutInfor] = useState({
    dataTable: [],
    count: 0,
  })
  const [pagePagination, setPagePagination] = useState({
    searchQuery: '',
    limit: 10,
    offset: 0,
  })

  const { loading, error, data } = useQuery(GET_ALL_SCHEDULE_GROUPS, {
    variables: {
      searchQuery: pagePagination.searchQuery,
      limit: pagePagination.limit,
      offset: pagePagination.offset,
    },
    fetchPolicy: 'cache-and-network',
  })

  useEffect(() => {
    try {
      if (loading) return
      if (error) throw new Error(error.message)
      const { getAllScheduleGroupsEmployees } = data
      const list = getAllScheduleGroupsEmployees.rows.map((group) => {
        return {
          id: group.id,
          nombre: group.name,
          descripcion:
            group.description.length > 20
              ? group.description.substring(0, 20) + '...'
              : group.description,

          inicia: group.GroupsToGroupDetails.start_day_of_week_spanish,
          termina: group.GroupsToGroupDetails.end_day_of_week_spanish,
          'Hora inicio': moment(
            group.GroupsToGroupDetails.start_time,
            'HH:mm:ss'
          ).format('hh:mm A'),
          'Hora fin': moment(
            group.GroupsToGroupDetails.end_time,
            'HH:mm:ss'
          ).format('hh:mm A'),
          'Tolerancia (min)':
            group.GroupsToGroupDetails.tolerance_minutes + ' min',
        }
      })

      setLayoutInfor({
        dataTable: list,
        count: getAllScheduleGroupsEmployees.count,
      })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loading, error, data])
  return (
    <>
      <ContentHeader title="" breadcrumb="" windowTitle="Grupos de Horarios" />
      <LayoutTable
        title={'Grupos de Horarios'}
        hideId
        data={layoutInfor.dataTable}
        totalCount={layoutInfor.count}
        loadingData={loading}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
      />
    </>
  )
}

export default ScheduleGroups
